<div class="py-4">
    <div *ngIf="isLoading; else content">
        <div class="d-flex justify-content-center py-2">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <ng-template #content>
        <form [formGroup]="depositForm">
            <mat-form-field appearance="outline" color="primary">
                <mat-label>Data kontraktu:</mat-label>
                <input matInput [matDatepicker]="contractPicker" [formControl]="date_contract">
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="contractPicker"></mat-datepicker-toggle>
                <mat-datepicker #contractPicker (closed)="setContractDate()"></mat-datepicker>
            </mat-form-field>
            <div class="pt-2">
                <mat-form-field class="half-width pt-2" appearance="outline">
                    <mat-label>Numer kontraktu:</mat-label>
                    <input matInput formControlName="contract_no" name="contract_no" type="text"
                           placeholder="Numer kontraktu"
                           #contractNoLength>
                    <mat-hint align="end">
                        {{ contractNoLength.value.length }} / {{ contractNoMaxLength }}
                    </mat-hint>
                    <mat-error *ngIf="contractNo.errors?.['required']">
                        Podaj numer kontraktu.
                    </mat-error>
                    <mat-error
                        *ngIf="contractNo.value.length < contractNoMinLength && !contractNo.errors?.['required']">
                        Minimalna długość wynosi {{ contractNoMinLength }} znaków.
                    </mat-error>
                    <mat-error *ngIf="contractNo.value.length > contractNoMaxLength">
                        Maksymalna długość wynosi {{ contractNoMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="pt-2">
                <mat-form-field class="half-width" appearance="outline">
                    <mat-label>Inwestor:</mat-label>
                    <input matInput formControlName="investor" name="investor" type="text" placeholder="Inwestor"
                           #investorLength>
                    <mat-hint align="end">
                        {{ investorLength.value.length }} / {{ investorMaxLength }}
                    </mat-hint>
                    <mat-error *ngIf="investor.errors?.['required']">
                        Podaj nazwę inwestora.
                    </mat-error>
                    <mat-error *ngIf="investor.value.length < investorMinLength && !investor.errors?.['required']">
                        Minimalna długość wynosi {{ investorMinLength }} znaków.
                    </mat-error>
                    <mat-error *ngIf="investor.value.length > investorMaxLength">
                        Maksymalna długość wynosi {{ investorMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="pt-2">
                <mat-form-field appearance="outline" color="primary">
                    <mat-label>Data zwrotu</mat-label>
                    <input matInput [matDatepicker]="returnPicker" [formControl]="date_return">
                    <mat-hint>DD/MM/YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="returnPicker"></mat-datepicker-toggle>
                    <mat-datepicker #returnPicker (closed)="setReturnDate()"></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="pt-2 mx-md-3" appearance="outline">
                    <mat-label>Wartość:</mat-label>
                    <input matInput formControlName="amount" name="amount" type="number" placeholder="0" [min]="0">
                    <mat-icon color="primary" matSuffix>price_change</mat-icon>
                    <mat-error *ngIf="amount.errors?.['required']">
                        Podaj wartość depozytu
                    </mat-error>
                </mat-form-field>
            </div>
            <mat-form-field class="full-width pt-3" appearance="outline">
                <mat-label>Komentarz:</mat-label>
                <textarea matInput formControlName="comment" name="comment" type="text"
                          placeholder="Komentarz" #commentLength></textarea>
                <mat-hint align="end">
                    {{ commentLength.value.length }} / {{ commentMaxLength }}
                </mat-hint>
                <mat-error *ngIf="comment.errors?.['required']">
                    Napisz komentarz.
                </mat-error>
                <mat-error *ngIf="comment.value.length < commentMinLength && !comment.errors?.['required']">
                    Minimalna długość wynosi {{ commentMinLength }} znaków.
                </mat-error>
                <mat-error *ngIf="comment.value.length > commentMaxLength">
                    Maksymalna długość wynosi {{ commentMaxLength }} znaków.
                </mat-error>
            </mat-form-field>
        </form>
    </ng-template>
</div>
